package ui.external.materialui

object Severity {
    const val error = "error"
    const val warning = "warning"
}
